module.exports = __webpack_public_path__ + "img/1.95a90be9.jpg";